import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  loadingBoxEarnedOn: {
    height: 20,
    width: 100,
  },
  loadingBoxFqv: {
    height: 20,
    width: 60,
  },
  loadingBoxNew: {
    height: 20,
    width: 40,
  },
});
